import { useAuth } from "@/lib/auth";
import { useGetChildrenQuery } from "@/query/apiSlice";

export function useChildren() {
  const { isAuthenticated } = useAuth();
  const {
    data: children = [],
    isLoading,
    isFetching,
    refetch,
  } = useGetChildrenQuery(undefined, {
    skip: !isAuthenticated,
  });

  return {
    children,
    // Only the initial load — do not treat background refetch (e.g. refetchOnFocus)
    // as loading, or screens that unmount on isLoading will reset local form state.
    isLoading,
    isFetching,
    refetch,
  };
}
